// removed by extract-text-webpack-plugin
module.exports = {"CelebritiesList":"Celebrities__CelebritiesList__2z_dC"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Celebrities/Celebrities.css
// module id = 191
// module chunks = 0